module.exports = __webpack_public_path__ + "008b78a52537759fbfcb723bb927ec7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_60.jpg
// module id = 1786
// module chunks = 5